import React, { useEffect } from "react";
import { useUserTaskContext } from "../context";
import { Card, Grid2 as Grid, Typography } from "@mui/material";
import { calculateDaysDiff } from "components/DateTime/daysDiffUtilityFunction";

export const SummaryUsersTask = () => {
  const { list, reloadRequired, setReloadRequired, summary, setSummary } =
    useUserTaskContext();
  useEffect(() => {
    let doneAfterDeadline = 0;
    let acceptedAfterDeadline = 0;
    let ackAfterDeadline = 0;
    let pendingDone = 0;
    let pendingAck = 0;
    let pendingAcceptance = 0;
    let totalTasks = 0;
    list.forEach((item) => {
      const doneDiff = calculateDaysDiff(item.deadline, item.doneOn);
      const acceptDiff = calculateDaysDiff(item.deadline, item.acceptanceOn);
      const ackDiff = calculateDaysDiff(item.deadline, item.acknowledgeOn);
      if (doneDiff < 0 && item.doneStatus) {
        doneAfterDeadline++;
      }
      if (acceptDiff < 0 && item.acceptanceStatus) {
        acceptedAfterDeadline++;
      }
      if (ackDiff < 0 && item.acknowledgeStatus) {
        ackAfterDeadline++;
      }
      if (!item.doneStatus) {
        pendingDone++;
      }
      if (!item.acknowledgeStatus) {
        pendingAck++;
      }
      if (item.acceptanceStatus === "PENDING") {
        pendingAcceptance++;
      }
      totalTasks++;
    });
    setSummary({
      doneAfterDeadline,
      acceptedAfterDeadline,
      ackAfterDeadline,
      pendingDone,
      pendingAck,
      pendingAcceptance,
      totalTasks,
    });
    setReloadRequired(false);
  }, [reloadRequired]);
  return (
    <Grid container spacing={2}>
      <Grid container size={{ xs: 6, md: 3, lg: 3 }}>
        <Card variant="outlined" style={{ width: "100%" }}>
          <Typography variant="h6" gutterBottom>
            Total Tasks
          </Typography>
          <Typography variant="h4" color="primary">
            {summary.totalTasks}
          </Typography>
        </Card>
      </Grid>

      <Grid container size={{ xs: 6, md: 3, lg: 3 }}>
        <Card variant="outlined" style={{ width: "100%" }}>
          <Typography variant="h6" gutterBottom>
            Done after deadline
          </Typography>
          <Typography variant="h4" color="primary">
            {summary.doneAfterDeadline}
          </Typography>
        </Card>
      </Grid>
      <Grid container size={{ xs: 6, md: 3, lg: 3 }}>
        <Card variant="outlined" style={{ width: "100%" }}>
          <Typography variant="h6" gutterBottom>
            Accepted after deadline
          </Typography>
          <Typography variant="h4" color="primary">
            {summary.acceptedAfterDeadline}
          </Typography>
        </Card>
      </Grid>
      <Grid container size={{ xs: 6, md: 3, lg: 3 }}>
        <Card variant="outlined" style={{ width: "100%" }}>
          <Typography variant="h6" gutterBottom>
            Acknowledged after deadline
          </Typography>
          <Typography variant="h4" color="primary">
            {summary.ackAfterDeadline}
          </Typography>
        </Card>
      </Grid>
      <Grid container size={{ xs: 6, md: 3, lg: 3 }}>
        <Card variant="outlined" style={{ width: "100%" }}>
          <Typography variant="h6" gutterBottom>
            Pending Acceptance
          </Typography>
          <Typography variant="h4" color="primary">
            {summary.pendingAcceptance}
          </Typography>
        </Card>
      </Grid>
      <Grid container size={{ xs: 6, md: 3, lg: 3 }}>
        <Card variant="outlined" style={{ width: "100%" }}>
          <Typography variant="h6" gutterBottom>
            Pending Done
          </Typography>
          <Typography variant="h4" color="primary">
            {summary.pendingDone}
          </Typography>
        </Card>
      </Grid>
      <Grid container size={{ xs: 6, md: 3, lg: 3 }}>
        <Card variant="outlined" style={{ width: "100%" }}>
          <Typography variant="h6" gutterBottom>
            Pending Acknowledgement
          </Typography>
          <Typography variant="h4" color="primary">
            {summary.pendingAck}
          </Typography>
        </Card>
      </Grid>

      {/* todays deadline */}
      {/* <Grid container size={{ xs: 12, md: 4 }}>
        <Card variant="outlined" style={{ width: "100%" }}>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Deadline as Today
            </Typography>
            <Typography variant="h4" color="success.main">
              {summary.deadlineReached}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
 */}
      {/* Deadline passed */}
      {/* <Grid container size={{ xs: 12, md: 4 }}>
        <Card variant="outlined" style={{ width: "100%" }}>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Deadline Passed
            </Typography>
            <Typography variant="h4" color="error.main">
              {summary.deadlinePassed}
            </Typography>
          </CardContent>
        </Card>
      </Grid> */}
    </Grid>
  );
};
